import { apiService } from "./apiService";

export const statsNum = async (params: statsNumProps): Promise<statsNumResponse> => {
  try {
    const response = await apiService.get<statsNumResponse>("/stats/sum", params);
    return response;
  } catch (error) {
    throw error;
  }
};